import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { LocationOptionResource } from "../../types/location";
import { LocationMultiSelectField } from "../../ui/LocationSelectFields";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
}

export const AccordionItemLocation: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<LocationOptionResource[]>(name);
	const { locations, locationsIsLoading, renderLocationsAsCheckboxes } = useEventFilterAccordionItems();

	if (!locations || !locations.length) {
		return null;
	}

	const renderBody = () => {
		if (locationsIsLoading) return <Loading />;
		if (renderLocationsAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{locations.map((location) => (
						<FilterCheckbox
							key={`${location.id}`}
							name={`location-${location.id}`}
							value={value.some((v) => v.id === location.id)}
							label={location.name}
							onChange={(e) =>
								setValue(e.target.value ? [...value, location] : value.filter((v) => v.id !== location.id))
							}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <LocationMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={t("Location")}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			initialOpen={value && value.length > 0}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
